<template lang="pug">
	.campaign-podcasts-selection
		.flex-row.space
			template(v-if="activePodcast")
				PodcastDetailView(:record="activePodcast")
					template(slot="actions-right")
						DxSelectBox(:data-source="adRunTypes", :value.sync="runType", displayExpr="name", valueExpr="id", stylingMode="filled", :width="120")
					.flex-row.space(slot="actions-bottom")
						DxButton(:text="$tCaption('Back to podcasts')", @click="activePodcast = null", icon="fas fa-chevron-left")
						DxButton(v-if="productPodcasts.indexOf(activePodcast.id) == -1" :text="$tCaption('Select podcast')", type="success", @click="addPodcast", icon="fas fa-check")
						DxButton(v-else, :text="$tCaption('Remove podcast')", type="danger", @click="removePodcast", icon="fas fa-trash")
			template(v-show="!activePodcast")
				ListView.full-width(v-show="!activePodcast", ref="listView", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadPodcasts", :columns="columns", 
					:pageSize="6", :columnAutoWidth="false", initialView="cards", :hideViewsSelection="true")
					.flex-row(slot="left-actions")
						slot(name="left-actions")
					.filters-panel.flex-col(slot="left")
						.font-tiny.grey {{$tCaption('Filters')}}
						RangeFilter(v-model="filters.reach", :title="$tCaption('Reach')", width="140px")
						RangeFilter(v-model="filters.cpm", :title="$tCaption('CPM')", width="140px")
						RangeFilter(v-model="filters.cost", :title="$tCaption('Cost')", width="140px")
						RangeFilter(v-model="filters.gender", :title="$tCaption('Gender')", :min="0", :max="100", :textResolver="getGenderLabels", :step="0.5", width="140px")
						RangeFilter(v-model="filters.age", :title="$tCaption('Avg. age')", :min="0", :max="100", width="140px")
						RangeFilter(v-model="filters.income", :title="$tCaption('Avg. income')", :min="0", :max="200", width="140px")
						RangeFilter(v-model="filters.education", :title="$tCaption('Avg. education')", :source="educationLevelsSource", width="180px")
						DxButton(:text="$tCaption('Apply filters')", type="default", @click="$refs.listView.loadData({ clear: true })")
					template(v-slot:card="{ data }")
						.flex-col.podcast-card.clickable(@click="(v) => activePodcast = data", :class="{ selected: selectedPodcastIds.indexOf(data.Oid) > -1 }")
							.img
								.img-holder(:style="{ '--url': `url('${data.ImageUrl}')` }")
									.picture
								.reach.flex-row.space
									.icon
										i.fas.fa-podcast
									.flex-row.justify.align-center
										.flex-col
											.font-small.upper.grey {{$tCaption('Reach')}}
											.font-big {{formatNumber(data.Reach, 'fixedPoint', 0)}}
										.selected.flex-row.space.align-center(v-if="selectedPodcastIds.indexOf(data.Oid) > -1")
											i.fas.fa-check
											span {{$tCaption('Selected')}}
							.bottom.flex-col.space.padding
								b.title {{data.Name}}
								.description {{limitText(data.Description, 150)}}
					template(v-slot:listing-cell-template="{ data }")
						.flex-row.table-info.space.clickable(@click="(v) => activePodcast = data", :class="{ selected: selectedPodcastIds.indexOf(data.Oid) > -1 }")
							.img-holder(:style="{ '--url': `url(${data.ImageUrl})` }")
								.picture
							.flex-col.space
								b.title.wrap {{data.name}}
								.description.wrap {{limitText(data.description, 150)}}
</template>

<script>
	import Data from 'app-core/Data';
	import ListView from 'app-core/ListView.vue';
	import RangeFilter from 'app-core/RangeFilter.vue';
	import PodcastDetailView from '../podcast/DetailView.vue';
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';
	import { AD_RUN_TYPES } from 'app-core/constants'

	export default {
		translationCategory: 'proposal.PodcastsSelection',
		name: 'podcasts-selection',
		components: {ListView, RangeFilter, PodcastDetailView, DxButton, DxSelectBox},
		mixins: [Data.mixin],
		props: ['selected', 'info'],
		data() {
			return {
				columns: [
					{
						dataField: 'Name',
						caption: () => this.$tCaption('Listing'),
						cellTemplate: 'listing-cell-template',
						width: '120px'
					},
					{ dataField: 'Reach', caption: () => this.$tCaption('Reach'),  dataType: 'number', format: 'fixedPoint', width: '100px' },
					{ dataField: 'RatePrice', caption: () => this.$tCaption('CPM'),  dataType: 'number', format: { type: 'fixedPoint', precision: 2 }, width: '100px'  },
					{ dataField: '', name: 'Name1', caption: '' }
				],
				filters: {
					reach: [null, null],
					cpm: [null, null],
					cost: [null, null],
					gender: [0, 100],
					age: [0, 100],
					income: [0, 200],
					education: [0, 2]
				},
				educationLevelsSource: [],
				activePodcast: null,
				selectedPodcastIds: this.selected || [],
				adRunTypes: AD_RUN_TYPES.toLocale('name', this),
				runType: 0
			};
		},
		computed: {
			productPodcasts() {
				return this.productInfo && this.productInfo.podcasts || (this.activePodcastId ? [this.activePodcastId] : []);
			},
			stationIdsCondition() {
				const stationIds = this.info?.campaign?.Stations?.map(f => f?.Oid)?.join(',');
				return stationIds ? `&stationIds=${stationIds}` : '';
			}
		},
		created() {
			if (__DEBUG__)
				window.campaignPodcastSelection = this;
			Data.getEducationLevels().then(r => this.educationLevelsSource = r);
		},
		methods: {
			limitText(text, limit) {
				if (text?.length > limit) {
					return `${text.slice(0, limit)}...`;
				}
				return text;
			},
			loadPodcasts(pageIndex, size) {
				var params = [
					this.filters.gender[1] < 100 ? `maxMaleListeners=${(100 - this.filters.gender[1]) * 2 || null}` : `minMaleListeners=${this.filters.gender[0] * 2 || null}` ,
					`minAvgAge=${this.filters.age[0] || null}`,
					`maxAvgAge=${this.filters.age[1] < 100 ? this.filters.age[1] : null}`,
					`minAvgIncome=${this.filters.income[0] || null}`,
					`maxAvgIncome=${this.filters.income[1] < 200 ? this.filters.income[1] : null}`,
					`minEducation=${this.filters.education[0] > 0 ? (this.filters.education[0] + 1) : null}`,
					`maxEducation=${this.filters.education[1] < 2 ? (this.filters.education[1] + 1) : null}`,
					`minRate=${this.filters.cpm[0] || null}`,
					`maxRate=${this.filters.cpm[1] || null}`,
					`minReach=${this.filters.reach[0] || null}`,
					`maxReach=${this.filters.reach[1] || null}`,
					`minCost=${this.filters.cost[0] || null}`,
					`maxCost=${this.filters.cost[1] || null}`,
				];
				params.push(`page=${pageIndex + 1}`);
				
				return Data.getExternalApi('Podcast/GetPodcasts', `${params.filter(f => !f.endsWith('=null')).join('&')}${this.stationIdsCondition}&needFilterByUser=${this.$auth.proposalSettings().onlyMyPodcasts}`, size).then(r => {
					if (__DEBUG__)
						console.info('Podcasts loaded', { r, params, pageIndex, size });
					return r;
				});
			},
			getGenderLabels(sender, position, value) {
				if (value[1] < 100) {
					if (position === 'right')
						return `min. ${this.$tCaption('Female')} ${Math.min((100 - value[1]) * 2, 100)}%`;
				} else if (value[0] > 0) {
					if (position === 'left')
						return `min. ${this.$tCaption('Male')} ${Math.min(value[0] * 2, 100)}%`;
				}

				switch(position) {
					case 'left':
						return this.$tCaption('Male');
					case 'right':
						return this.$tCaption('Female');
				}
			},
			addPodcast() {
				this.productPodcasts.push(this.activePodcast.Oid);
				this.$emit('select', this.activePodcast, this.runType);
				this.activePodcast = null;
			},
			removePodcast() {
				this.productPodcasts.splice(this.productPodcasts.indexOf(this.activePodcast.Oid), 1);
				this.$emit('remove', this.activePodcast, this.runType);
				this.activePodcast = null;
			}
		}
	};
</script>
<style lang='scss'>
	.campaign-podcasts-selection {
		@import "main/themes/generated/variables.base.scss";

		.card {
			min-width: calc(33% - 40px);
			flex-basis: 300px;
		}

		.filters-panel {
			padding: 20px;
			background: #fff;
			border-radius: 4px;

			> *:not(:first-child) {
				margin-top: 20px;
			}
		}

		.table-info {
			.img-holder {
				width: 80px;
				height: 80px;
				min-width: 80px;

				background-image: var(--url);
				background-size: cover;
				background-position: center;
				border-radius: 4px;
			}
		}
		.podcast-card {
			-webkit-box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			-moz-box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			min-width: 240px;
			border-radius: 10px;
			overflow: hidden;

			.selected {
				padding: 6px;
				background: $base-accent;
				color: #fff;
				border-radius: 4px;
			}

			.img {
				position: relative;

				.img-holder {
					transition: 0.75s;
					height: 200px;
					width: 100%;
					overflow: hidden;

					.picture {
						width: 100%;
						height: 100%;
						background-image: var(--url);
						background-size: cover;
						background-position: center;
						filter: grayscale(76%);
						transform: scale(1);
						transition: 0.65s;
					}
				}

				> img {
					width: 100%;
				}

				.reach {
					transition: 0.75s;
					position: absolute;
					z-index: 1;
					width: 100%;
					height: 65px;
					background: rgba(0, 0, 0, 0.5);
					bottom: 0px;
					color: #fff;
					padding: 10px 20px;

					> .icon {
						font-size: 35px;
					}
				}
			}

			.bottom {
				background: #fff;
				border-top: 2px solid $base-accent;
			}

			&:hover {
				.img-holder {
					.picture {
						transform: scale(1.1);
						filter: grayscale(0%);
					}
				}
				.reach {
					background: rgba(0, 0, 0, 0.8);
					padding: 10px 30px;
					color: $base-accent;
				}
			}

			&.selected {
				.reach {
					background: $base-accent-transparent;
					color: $base-accent;

					.grey {
						color: $base-accent-transparent !important;
					}
				}
			}
		}
	}
</style>
